/*
login-navbar-ctrl.js

-GE CONFIDENTIAL-
Type: Source Code

Copyright (c) 2021, GE Healthcare Co.
All Rights Reserved

This unpublished material is proprietary to GE Healthcare. The methods and
techniques described herein are considered trade secrets and/or
confidential. Reproduction or distribution, in whole or in part, is
forbidden except by express written permission of GE Healthcare.
*/
define('login/modules/login-navbar/controllers/login-navbar-ctrl',[
    'angular',
    '../services/login-navbar-i18n',
    'sharedConstants'
], function() {

    // Module Dependencies
    var dependencies = [
        'LoginNavbar.Services.i18n',
        'Services.SharedConstants'
    ];

    // Module Definition
    var mod = angular.module('LoginNavbar.Controllers.LoginNavbarCtrl', dependencies);

    /**
     * @name LoginNavbarCtrl
     * @type controller
     *
     * @description
     * Controller for the 'Login' page's navigation bar.
     */
    mod.controller('LoginNavbarCtrl', ['$rootScope', '$scope', '$timeout', 'LoginNavbar.i18n', 'sharedConstants',
        function($rootScope, $scope, $timeout, i18n, sharedConstants) {
            // Collection of localized messages
            $scope.msg = i18n.getMessages();

            // get messages texts for case automation screen
            var alertMessages = sharedConstants.getAlertMessages();

            // Displaying/Hiding success message on successfully changing a password
            if (sessionStorage.passwordChanged) {
                $rootScope.$emit(alertMessages.SHOW_SUCCESS_MESSAGE, $scope.msg.resetPasswordSuccessText);
                // delete password changed cookie once password get changed
                delete sessionStorage.passwordChanged;
            } else {
                angular.element('#successText').parent().hide();
            }
        }
    ]);

});

